import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './authApi';

export const promotionsApi = createApi({
  reducerPath: 'promotionsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['PosPromotion'],
  endpoints: (builder) => ({

    // GET /api/v1/pos/promotions
    // Returns currently valid, active promotions for the cashier's store.
    // Called when the Promotions modal opens.
    getPosPromotions: builder.query({
      query: () => '/promotions',
      providesTags: [{ type: 'PosPromotion', id: 'LIST' }],
    }),

  }),
});

export const {
  useGetPosPromotionsQuery,
} = promotionsApi;
